<h1 mat-dialog-title>Artikel zur Entnahme hinzufügen</h1>

<mat-dialog-content>
  <form [formGroup]="deliveryArticleForm">
    <div class="filter-row">
      <mat-form-field appearance="fill" formGroupName="article">
        <mat-label>Artikel</mat-label>
        <mat-select formControlName="id">
          <mat-option>
            <ngx-mat-select-search [formControl]="articleFilterCtrl"></ngx-mat-select-search>
          </mat-option>
          @for (article of filteredArticles | async; track article) {
            <mat-option [value]="article.id">
              {{article.title}} ({{article.internalId}})
            </mat-option>
          }
        </mat-select>
      </mat-form-field>

      <button mat-flat-button type="button" color="primary" (click)="scanArticle()" class="scan-article-btn">
        Code scannen
        <mat-icon>qr_code_scanner</mat-icon>
      </button>
    </div>
  </form>

  <!-- Außerhalb des Formulars: Enter in der Mengeneingabe würde sonst das Formular absenden und den ersten
       Button (Code scannen) auslösen -->
  @if (deliveryArticleForm.get('article.id')?.value) {
    <div>
      <knust-article-storage-locations [displayedColumns]="displayedColumns" [disableAdminDisplayedColumns]="true"></knust-article-storage-locations>
    </div>
  }
</mat-dialog-content>

<mat-dialog-actions class="actions-row">
  <button mat-flat-button mat-dialog-close>Abbrechen</button>
</mat-dialog-actions>
